import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tracking extends Component {
    static propTypes = {
        pathname: PropTypes.string,
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default Tracking;



/** WEBPACK FOOTER **
 ** /src/shared/parts/tracking/index.js
 **/